export const environmentTest = {
    googleApiKey: 'AIzaSyCVEd_4nX6cv6RMPtULp8TMi-CD628NckY'
};

export const environmentProd = {
    googleApiKey: 'AIzaSyAiy0ARqlUVnuT6ongl1HotOoOJWhz5ba4'
};
